/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconOutlet = createReactComponent("outline", "outlet", "IconOutlet", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["circle", { "cx": "9", "cy": "12", "r": ".5", "fill": "currentColor", "key": "svg-1" }], ["circle", { "cx": "15", "cy": "12", "r": ".5", "fill": "currentColor", "key": "svg-2" }]]);

export { IconOutlet as default };
//# sourceMappingURL=IconOutlet.mjs.map
